import { IPhotoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { showGalleryElement } from '../../../store/gallery';
import { Controls, IControlsProps } from './controls';
import { setNewbuildingMvkIsWidgetOpenAction } from '../../../store/newbuilding_mvk';

type TStoreProps = Pick<
  IControlsProps,
  'isInitialized' |
  'isSingleGalleryCount' |
  'isVideo' |
  'isVideoPlay' |
  'layoutId' |
  'photoCount' |
  'isFloorPlan'
>;

type TDispatchProps = Pick<
  IControlsProps,
  'onElementShow' |
  'openMvkWidget'
>;

function mapStateToProps(state: IState): TStoreProps {
  return {
    isInitialized: state.gallery.isInitialized,
    isSingleGalleryCount: isSingleGalleryItem(state),
    isVideo: state.offerData.offer.videos && state.offerData.offer.videos.length > 0 ? true : undefined,
    isVideoPlay: state.gallery.isVideoPlayed,
    layoutId: getLayoutPositionId(state.offerData.offer.photos),
    photoCount: getPhotoCount(state.offerData.offer.photos, state.newbuildingMvk.offerFloorPlanImage) || undefined,
    isFloorPlan: Boolean(state.newbuildingMvk.MVKData),
  };
}

// tslint:disable-next-line:no-any
export const GalleryControlsContainer = connect<TStoreProps, TDispatchProps, {}>(
  mapStateToProps,
  (dispatch: Dispatch<IState>): TDispatchProps => ({
    onElementShow: (id: number) => {
      dispatch(showGalleryElement(id));
    },
    openMvkWidget: () => dispatch(setNewbuildingMvkIsWidgetOpenAction(true)),
  }),
)(Controls);

function isSingleGalleryItem(state: IState) {

  const videoCount = state.offerData.offer.videos ? state.offerData.offer.videos.length : 0;
  const photoCount = getPhotoCount(state.offerData.offer.photos, state.newbuildingMvk.offerFloorPlanImage);

  const itemsCount = videoCount + photoCount;

  return itemsCount <= 1;
}

function getLayoutPositionId(photo: IPhotoSchema[] | null) {
  if (photo) {
    let positionId: number | undefined;
    photo.forEach((element: IPhotoSchema, index: number) => {
      if (element.isLayout) {
        positionId = index;
      }
    });

    return positionId;
  }

  return undefined;
}

function getPhotoCount(photos?: IPhotoSchema[] | null, offerFloorPlanImage?: string) {
  return (photos || []).length + Number(!!offerFloorPlanImage);
}
